import React, { useEffect, useState } from 'react';
import {
    Box,
    Button,
    Checkbox,
    ExpansionPanel,
    FormControlLabel,
    Grid,
    InputLabel,
    makeStyles,
    TextField,
    withStyles
} from '@material-ui/core';
import Modal from '../common/SimpleModal';
import notificationsStyle from './style';
import SmsTab from './tabs/Sms';
import EmailTab from './tabs/Email';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { ExpansionPanelSummary, ExpansionPanelDetails, Typography } from '@material-ui/core';
import CancelContinueModal from '../../collums-components/components/common/CancelContinueModal';
import { modalsButtonStyles } from '../../collums-constants/styles/stylesheets/buttonsStyles';
import CategoryApi from '../../collums-components/api/CategoryApi';
import ServiceApi from '../../collums-components/api/ServiceApi';
import { toastr } from 'react-redux-toastr';

const Accordion = ({ children, title, className, onChange }) => {
    return (
        <ExpansionPanel className={className} onChange={onChange}>
            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>{title()}</ExpansionPanelSummary>
            <ExpansionPanelDetails>{children}</ExpansionPanelDetails>
        </ExpansionPanel>
    );
};

const PreAfterCareModal = ({
    notification,
    closeModal,
    classes,
    isPreAfterCare = false,
    generalTabSaveHandler,
    clinics = []
}) => {
    const [currentPanel, setCurrentPanel] = useState('');
    const [isShowingExitConfirmation, setIsShowingExitConfirmation] = useState(false);
    const [haveEmailUnsavedChanges, setHaveEmailUnsavedChanges] = useState(false);
    const [haveSMSUnsavedChanges, setHaveSMSUnsavedChanges] = useState(false);
    const [categories, setCategories] = useState([]);
    const [data, setData] = useState({});

    const globalStyles = makeStyles(modalsButtonStyles)();
    const closeAccordion = () => {
        setCurrentPanel('');
    };

    const exitConfirmation = () => {
        setIsShowingExitConfirmation(false);
        closeModal();
    };

    const showConfirmationDialog = () => {
        if (haveEmailUnsavedChanges || haveSMSUnsavedChanges) setIsShowingExitConfirmation(true);
        else closeModal();
    };

    useEffect(() => {
        setData({
            name: notification?.name || '',
            description: notification?.description || ''
        });
    }, [notification]);

    const disableTransition = { transition: 'none' };

    const saveGeneralTabButtonHandler = () => {
        const selectedServices = [];
        for (const cat of categories) {
            if (!cat.selected) {
                for (const srv of cat.services) {
                    if (srv.selected) {
                        selectedServices.push(srv);
                    }
                }
            }
        }
        generalTabSaveHandler(
            { ...data, categories: categories.filter(cat => cat.selected), services: selectedServices },
            notification.id
        );
    };

    const loadCategories = async () => {
        try {
            let categ = await CategoryApi.filter('', false, null, true);
            let subcateg = await CategoryApi.filter('', true, null, true);
            categ = [...categ, ...subcateg]
                .map(cat => ({ name: cat.name, id: cat.id }))
                .sort((a, b) => a.name.localeCompare(b.name));
            const uniqueById = arr => {
                return [...new Map(arr.map(item => [item.id, item])).values()];
            };
            const servicesAll = await ServiceApi.getServiceWithCategoriesID({
                categoriesIds: categ.map(cat => cat.id)
            });
            const services = uniqueById(servicesAll);
            categ = categ.map(cat => {
                const isCategorySelected = notification?.categories.includes(cat.id);
                return {
                    ...cat,
                    selected: isCategorySelected,
                    services: services
                        .filter(srv => cat.id === srv.category.id)
                        .map(srv => {
                            const isServiceSelected = isCategorySelected;
                            return {
                                name: srv.name,
                                id: srv.id,
                                selected: isServiceSelected || notification?.services.includes(srv.id)
                            };
                        })
                        .sort((a, b) => a.name.localeCompare(b.name))
                };
            });

            setCategories(categ);
        } catch (error) {
            toastr.error(error.data?.message || 'Something went wrong');
        }
    };

    useEffect(() => {
        loadCategories();
        // eslint-disable-next-line
    }, []);

    const categoryTitle = category => {
        return (
            <div className={classes.categoryTitle} key={`${category.id}-${category.allSelected}`}>
                <FormControlLabel
                    control={
                        <Checkbox
                            id="select-all-checkbox"
                            onClick={e => e.stopPropagation()}
                            checked={category.selected}
                            onChange={e => {
                                const isChecked = e.target.checked;

                                setCategories(prevState => {
                                    return prevState.map(cat => {
                                        if (cat.id !== category.id) {
                                            return cat;
                                        }
                                        return {
                                            ...cat,
                                            selected: isChecked,
                                            services: category.services.map(srv => {
                                                return {
                                                    ...srv,
                                                    selected: isChecked
                                                };
                                            })
                                        };
                                    });
                                });
                            }}
                            name="selectAllCategory"
                            color="primary"
                            indeterminate={!category.selected && category.services.filter(srv => srv.selected).length}
                        />
                    }
                />
                <Typography className={classes.bold}>{category.name}</Typography>
            </div>
        );
    };

    return (
        <>
            <Modal
                isOpen={true}
                title={`View/Edit ${notification.name} ${isPreAfterCare ? 'Pre/After care' : 'Notification'}`}
                id="notification"
                onClose={showConfirmationDialog}
                onCancel={showConfirmationDialog}
                size={'lg'}
                currentPanel={currentPanel}
            >
                <ExpansionPanel
                    onChange={() => {
                        if ('generalPanel' === currentPanel) setCurrentPanel('');
                        else setCurrentPanel('generalPanel');
                    }}
                    expanded={'generalPanel' === currentPanel}
                    className={classes.accordions}
                    style={disableTransition}
                    CollapseProps={{ classes: { container: { transition: 'none' } } }}
                >
                    <ExpansionPanelSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                    >
                        <Typography>General</Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                        <Grid container p={2} spacing={2}>
                            <Grid item xs={12} md={6}>
                                <TextField
                                    value={data.name}
                                    onChange={({ target }) => setData({ ...data, name: target.value })}
                                    className={classes.formItem}
                                    variant="outlined"
                                    label="Name"
                                    required
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <TextField
                                    value={data.description}
                                    label="Description"
                                    onChange={({ target }) => setData({ ...data, description: target.value })}
                                    className={classes.formItem}
                                    variant="outlined"
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <div className={classes.tagsContainer}>
                                    <div style={{ width: '100%' }}>
                                        <InputLabel shrink className={classes.categoriesEditLabel}>
                                            Send to these services
                                        </InputLabel>
                                        {categories.map(category => (
                                            <Accordion
                                                className={category.isSub && classes.accordion}
                                                key={category.id}
                                                title={() => categoryTitle(category)}
                                                typographyClassName="checkbox"
                                            >
                                                <div className={classes.serviceContainer}>
                                                    <Box>
                                                        {category.services.map((service, index) => {
                                                            return (
                                                                <div key={index} className={classes.serviceRow}>
                                                                    <div>
                                                                        <Checkbox
                                                                            checked={service.selected}
                                                                            onChange={(e, isChecked) => {
                                                                                setCategories(prevState => {
                                                                                    return prevState.map(cat => {
                                                                                        if (cat.id !== category.id) {
                                                                                            return cat;
                                                                                        }
                                                                                        const catServices = category.services.map(
                                                                                            srv => {
                                                                                                if (
                                                                                                    srv.id !==
                                                                                                    service.id
                                                                                                ) {
                                                                                                    return srv;
                                                                                                }
                                                                                                return {
                                                                                                    ...srv,
                                                                                                    selected: isChecked
                                                                                                };
                                                                                            }
                                                                                        );
                                                                                        const allServicesSelected =
                                                                                            catServices.length ===
                                                                                            catServices.filter(
                                                                                                srv => srv.selected
                                                                                            ).length;
                                                                                        return {
                                                                                            ...cat,
                                                                                            selected: allServicesSelected,
                                                                                            services: catServices
                                                                                        };
                                                                                    });
                                                                                });
                                                                            }}
                                                                        />
                                                                    </div>
                                                                    <div
                                                                        className={classes.horizontallyCenteredRowItem}
                                                                    >
                                                                        <Typography>{service.name}</Typography>
                                                                    </div>
                                                                </div>
                                                            );
                                                        })}
                                                    </Box>
                                                </div>
                                            </Accordion>
                                        ))}
                                    </div>
                                </div>
                            </Grid>
                            <Grid item xs={12} className={globalStyles.buttonsContainer}>
                                <Button className={globalStyles.cancelButton} onClick={showConfirmationDialog}>
                                    Cancel
                                </Button>
                                <Button className={globalStyles.confirmButton} onClick={saveGeneralTabButtonHandler}>
                                    Save
                                </Button>
                            </Grid>
                        </Grid>
                    </ExpansionPanelDetails>
                </ExpansionPanel>
                <ExpansionPanel
                    onChange={() => {
                        if ('emailPanel' === currentPanel) setCurrentPanel('');
                        else setCurrentPanel('emailPanel');
                    }}
                    expanded={'emailPanel' === currentPanel}
                    className={classes.accordions}
                    style={disableTransition}
                    CollapseProps={{ classes: { container: { transition: 'none' } } }}
                >
                    <ExpansionPanelSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                    >
                        <Typography>{notification.name} Email</Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                        <EmailTab
                            notification={notification}
                            closeAccordion={closeAccordion}
                            setHaveEmailUnsavedChanges={setHaveEmailUnsavedChanges}
                            isPreAfterCare={isPreAfterCare}
                            clinics={clinics}
                        />
                    </ExpansionPanelDetails>
                </ExpansionPanel>
                {notification.from !== 'Form' && (
                    <ExpansionPanel
                        onChange={() => {
                            if ('smsPanel' === currentPanel) setCurrentPanel('');
                            else setCurrentPanel('smsPanel');
                        }}
                        className={classes.accordions}
                        expanded={'smsPanel' === currentPanel}
                        style={disableTransition}
                        CollapseProps={{ classes: { container: { transition: 'none' } } }}
                    >
                        <ExpansionPanelSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                        >
                            <Typography>{notification.name} SMS</Typography>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails>
                            <SmsTab
                                notification={notification}
                                closeAccordion={closeAccordion}
                                setHaveSMSUnsavedChanges={setHaveSMSUnsavedChanges}
                            />
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                )}
            </Modal>
            {isShowingExitConfirmation && (
                <CancelContinueModal
                    setOpen={setIsShowingExitConfirmation}
                    title="Your changes will not be saved"
                    contentText="Are you sure you want to continue?"
                    onContinue={exitConfirmation}
                />
            )}
        </>
    );
};

export default withStyles(notificationsStyle)(PreAfterCareModal);
